export default __webpack_public_path__ + "static/media/lackier_group.2b828e37.png";